package org.hs_soft.runmynesto.domain.model.home.home.global_search


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GlobalSearch(
    @SerialName("code")
    val code: String?,
    @SerialName("date")
    val date: String?,
    @SerialName("id")
    val id: String?,
    @SerialName("name")
    val name: String?,
    @SerialName("number")
    val number: Int?,
    @SerialName("__typename")
    val typename: String?
)